const ROOT_HOSTS = (process.env.REACT_APP_ROOT_HOSTS || "gredus.com")
  .split(",")
  .map((h) => h.trim())
  .filter(Boolean);

const stripWww = (host) => (host.startsWith("www.") ? host.slice(4) : host);

export const getRootDomain = (hostname = window.location.hostname) => {
  const host = stripWww(hostname.toLowerCase());
  let match = null;
  for (const root of ROOT_HOSTS) {
    if (host === root || host.endsWith("." + root)) {
      if (!match || root.length > match.length) match = root;
    }
  }
  return match;
};

export const isRootDomain = (hostname = window.location.hostname) => {
  const host = stripWww(hostname.toLowerCase());
  return ROOT_HOSTS.includes(host);
};

export const buildTenantLoginUrl = (slug, email, rootDomain = getRootDomain()) => {
  const protocol = window.location.protocol;
  const port = window.location.port ? `:${window.location.port}` : "";
  const root = rootDomain || ROOT_HOSTS[0];
  return `${protocol}//${slug}.${root}${port}/login?email=${encodeURIComponent(email)}`;
};

export const getCanonicalRootHost = () =>
  getRootDomain() || ROOT_HOSTS[ROOT_HOSTS.length - 1];
